import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import axios from 'axios';
export default abstract class TeacherProfileDao {
  static changePassword(
    env: Environment,
    currentPassword: string,
    password: string,
    accountName?: string,
    teacherId?: number
  ) {
    const url = hostsConfig[env].profileServiceUrl;

    return axios.post(`${url}/v1/profile/password/`, {
      accountName,
      accountPassword: password,
      newPassword: password,
      oldPassword: currentPassword,
      personId: teacherId,
    });
  }
}
